import React, { useContext } from 'react';
import { SubmitHandler, useForm } from "react-hook-form";
import { ILoginFormInput } from "./FormInput";
import { userAPI } from "../../../../Redux/services/UserService";
import { AuthContext } from "../../../../Infrastructure/provider/AuthProvider";
import { Navigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../../../Public/ASA.svg";

const LoginForm = () => {
    const { register, handleSubmit } = useForm<ILoginFormInput>();
    const [loginUser, { isError }] = userAPI.useLoginUserMutation();
    const { user, getUser } = useContext<any>(AuthContext);

    const login: SubmitHandler<ILoginFormInput> = async (data) => {
        try {
            const loginData = await loginUser(data).unwrap();
            localStorage.setItem('userToken', loginData.token);
            getUser();
        } catch (error) {
            console.log(error);
        }
    };

    if (user) {
        return <Navigate to="/category" replace />;
    }

    return (
        <div className="flex flex-col md:flex-row justify-center items-center min-h-[75vh]  px-6">
            {/* Левая часть — логотип и подпись */}
            <div className="flex flex-col items-center justify-center md:pr-20 mb-10 md:mb-0 text-center">
                <Logo className="w-[280px] md:w-[360px] lg:w-[420px] text-[#4573c4] fill-current transition-all duration-300 mr-0 lg:mr-32" />
                <p className="text-xl md:text-2xl text-black text-center mt-4 leading-snug font-pragmatica">
                    Система Інформування<br />Користувачів
                </p>
            </div>

            {/* Правая часть — форма */}
            <div className="bg-white border border-gray-300 shadow-md rounded-md px-6 sm:px-8 md:px-10 py-8 w-full max-w-[420px] flex flex-col items-center">
                <h2 className="text-lg sm:text-xl mb-6 font-semibold text-[#4573c4] text-center">
                    Вхід до системи
                </h2>

                <form
                    onSubmit={handleSubmit(login)}
                    className="flex flex-col gap-4 w-full"
                >
                    <input
                        {...register("login", { required: true })}
                        type="text"
                        placeholder="Логін"
                        className="w-full border border-gray-300 rounded-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#4573c4]"
                    />
                    <input
                        {...register("password", { required: true })}
                        type="password"
                        placeholder="Пароль"
                        className="w-full border border-gray-300 rounded-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#4573c4]"
                    />

                    <button
                        type="submit"
                        className="w-full bg-[#7ac142] text-white font-semibold mt-4 py-2 rounded-sm hover:bg-[#6bb13a] transition-colors"
                    >
                        УВІЙТИ
                    </button>

                    {isError && (
                        <p className="text-sm text-red-500 mt-2 text-center">
                            Неправильний логін або пароль
                        </p>
                    )}
                </form>
            </div>
        </div>
    );
};

export default LoginForm;
